import React, { useState, useEffect } from 'react';
import { Menu, X, Star } from 'lucide-react';
const logo = '/LogoNew1.png';
import ReviewModal from './ReviewModal';

const Navbar = () => {
    const [isScrolled, setIsScrolled] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isReviewModalOpen, setIsReviewModalOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 50);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToSection = (id) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
            setIsMobileMenuOpen(false);
        }
    };

    return (
        <nav
            className={`fixed w-full top-0 z-50 transition-all duration-300 ${isScrolled ? 'glass shadow-lg py-2' : 'bg-transparent py-4'
                }`}
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center">
                    {/* Logo */}
                    <div className="flex items-center space-x-3">
                        <img src={logo} alt="Healthy Massage Logo" className="h-16 w-16 -my-2 object-contain" />
                        <div className="hidden sm:block">
                            <h1 className="text-lg font-display font-bold text-coffee-900">Healthy Massage Home Service</h1>
                            <p className="text-xs text-coffee-700">Bengaluru</p>
                        </div>
                    </div>

                    {/* Desktop Menu */}
                    <div className="hidden md:flex items-center space-x-8">
                        <button
                            onClick={() => scrollToSection('hero')}
                            className="text-coffee-900 hover:text-zen-gold transition-colors font-medium"
                        >
                            Home
                        </button>
                        <button
                            onClick={() => scrollToSection('about')}
                            className="text-coffee-900 hover:text-zen-gold transition-colors font-medium"
                        >
                            About
                        </button>
                        <button
                            onClick={() => scrollToSection('services')}
                            className="text-coffee-900 hover:text-zen-gold transition-colors font-medium"
                        >
                            Services
                        </button>
                        <button
                            onClick={() => scrollToSection('credentials')}
                            className="text-coffee-900 hover:text-zen-gold transition-colors font-medium"
                        >
                            Credentials
                        </button>
                        <button
                            onClick={() => setIsReviewModalOpen(true)}
                            className="flex items-center space-x-2 border-2 border-zen-gold text-coffee-900 hover:bg-zen-gold hover:text-white px-5 py-2 rounded-full transition-all duration-300 font-bold uppercase text-sm tracking-wide shadow-sm"
                        >
                            <Star size={16} className="fill-current" />
                            <span>Review</span>
                        </button>
                        <button
                            onClick={() => scrollToSection('contact')}
                            className="bg-zen-gold text-white px-6 py-2 rounded-full hover:bg-coffee-900 transition-all duration-300 font-semibold shadow-lg hover:shadow-glow"
                        >
                            Contact Us
                        </button>
                    </div>

                    {/* Mobile Menu Button */}
                    {/* Mobile Header Icons */}
                    <div className="flex md:hidden items-center space-x-4">
                        <button
                            onClick={() => setIsReviewModalOpen(true)}
                            className="text-coffee-900 hover:text-zen-gold transition-colors"
                            aria-label="Reviews"
                        >
                            <Star size={28} className="text-zen-gold" />
                        </button>
                        <button
                            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                            className="text-coffee-900 hover:text-zen-gold transition-colors"
                        >
                            {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
                        </button>
                    </div>
                </div>

                {/* Mobile Menu */}
                {isMobileMenuOpen && (
                    <div className="md:hidden mt-4 pb-4 glass rounded-lg">
                        <div className="flex flex-col space-y-3 px-4 py-3">
                            <button
                                onClick={() => scrollToSection('hero')}
                                className="text-coffee-900 hover:text-zen-gold transition-colors font-medium text-left py-2"
                            >
                                Home
                            </button>
                            <button
                                onClick={() => scrollToSection('about')}
                                className="text-coffee-900 hover:text-zen-gold transition-colors font-medium text-left py-2"
                            >
                                About
                            </button>
                            <button
                                onClick={() => scrollToSection('services')}
                                className="text-coffee-900 hover:text-zen-gold transition-colors font-medium text-left py-2"
                            >
                                Services
                            </button>
                            <button
                                onClick={() => scrollToSection('credentials')}
                                className="text-coffee-900 hover:text-zen-gold transition-colors font-medium text-left py-2"
                            >
                                Credentials
                            </button>
                            <button
                                onClick={() => scrollToSection('contact')}
                                className="bg-zen-gold text-white px-6 py-3 rounded-full hover:bg-coffee-900 transition-all duration-300 font-semibold shadow-lg text-center"
                            >
                                Contact Us
                            </button>
                        </div>
                    </div>
                )}
            </div>

            {/* Review Modal */}
            <ReviewModal
                isOpen={isReviewModalOpen}
                onClose={() => setIsReviewModalOpen(false)}
            />
        </nav>
    );
};

export default Navbar;
